import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { v4 } from 'uuid';
import { onActions } from '../../utils/helpers/redux.helper';
import {
  ActionsEnum,
  fetchFeaturesData,
  FetchFeaturesDataSuccess,
  fetchQuotasBannersCanvases,
} from './features-data.actions';
import { ProvisioningFeatures } from './provisioning-features.model';
import { map } from 'rxjs/operators';

@Injectable()
export class FeaturesDataDispatcher {
  constructor(private _store: Store<any>, private _actions: Actions) {}

  fetchQuotaBannersCanvases() {
    this._store.dispatch(fetchQuotasBannersCanvases());
  }

  fetchFeaturesData(dispatchId?: string): Observable<ProvisioningFeatures> {
    let requestId = dispatchId || v4();

    this._store.dispatch(fetchFeaturesData(requestId));

    return onActions(
      this._actions,
      [
        ActionsEnum.FETCH_FEATURES_DATA_SUCCESS,
        ActionsEnum.FETCH_FEATURES_DATA_ERROR,
      ],
      requestId
    ).pipe(
      map(({ payload }: FetchFeaturesDataSuccess) => payload.featuresData)
    );
  }
}
